module.exports = __webpack_public_path__ + "img/floor_f2_02.6151c683.png";